const ERROR_REQUIRED = 'This field is required.';

export type ChampionConsentFormValues = {
  name: string;
  email: string;
  /** Champions Program Agreement — matches `UnifiedChampionConsentInput.consentProgramAgreement` */
  consentProgramAgreement: boolean;
  /** Success Champion Agreement — matches `UnifiedChampionConsentInput.consentSuccessChampionAgreement` */
  consentSuccessChampionAgreement: boolean;
};

export type ChampionConsentFormErrors = Partial<Record<keyof ChampionConsentFormValues, string>>;

export const validateChampionConsentForm = (
  values: ChampionConsentFormValues
): ChampionConsentFormErrors => {
  const errors: ChampionConsentFormErrors = {};

  if (!values.consentProgramAgreement) {
    errors.consentProgramAgreement = ERROR_REQUIRED;
  }

  if (!values.consentSuccessChampionAgreement) {
    errors.consentSuccessChampionAgreement = ERROR_REQUIRED;
  }

  return errors;
};
